











































































































































































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { VHeaders, PaginationModel } from "@/models/pagedlistmodel";
import {
  SearchRepairOrderViewModel,
  SearchRepairOrderListViewModel,
  AttachmentInfoViewModel,
  MakeCallModel,
  CustomerSearchResult,
  VoiceCallModel,
} from "@/models/fixedops/repairorder";
import { NotificationHelper as _notification } from "@/helper/notifications.helper";
import { MetadataType, MetadataKeyIdentifier } from "@/enums/enums";
import { Base } from "@/components/common/base";
import { IDialogOption } from "@/models/dialog";
import {
  getClosedListheaders,
  getCustomerHeaders,
  getheaders,
} from "@/views/fixedOps/repairorder/repair.order";
import {
  repairOrderService,
  voiceCallService,
  customerService,
} from "@/shared";

let cachedSearchParameters: any[] | null = null;

@Component({
  props: ["methodName", "progress"],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import("@/components/common/app.grid.vue"),
    AttachmentForm: () => import("@/components/repairorder/attachment.add.vue"),
    AppDialog: () => import("@/components/common/app.dialog.vue"),
  },
})
class ClosedRepairOrderPage extends Base {
  public pagedRO: SearchRepairOrderListViewModel[] = [];
  public pagination = new PaginationModel("repairOrderNumber");
  public fileRef: any;
  public pagedCustomerList: CustomerSearchResult[] = [];
  public customerInfo: any = {};
  public customerPagination = new PaginationModel("firstName");
  public customerActions: any[] = [];
  public headers: VHeaders[] = getClosedListheaders(this);
  public customerHeaders: VHeaders[] = getCustomerHeaders(this);

  public loading: boolean = false;
  public actions: any[] = [];
  public searchParameters = [];
  public searchParametersLoading: boolean = false;
  public roLoading: boolean = false;
  public methodName: string = "";
  public childProgress: boolean = false;

  public constants: any = {
    searchParameter: "",
    searchString: "",
    lastName: "",
    firstName: "",
    customerNumber: "",
    roNumber: "",
    email: "",
    phone: "",
    customerKey: "",
  };
  public flags: any = {
    showForm: false,
    showAttachmentDetails: false,
    showEmailPopup: false,
  };
  public showCallPopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t("closedRepairOrders.callDialog.title") as string,
    model: false,
    action: {
      color: "success",
      icon: "fas fa-phone-volume",
      text: this.$parent.$t("closedRepairOrders.callDialog.btnCall") as string,
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.makeCall();
    },
  };
  public preventPaginationCall: boolean = false;

  public searchedRepairOrder: SearchRepairOrderViewModel = {};
  public attachmentDetails: AttachmentInfoViewModel[] = [];

  public customerPhoneNumber(): string {
    let pNumber = "";
    switch (this.customerInfo.callTo) {
      case "home": {
        pNumber = this.customerInfo.customerPhoneNumber;
        break;
      }
      case "cellphone": {
        pNumber = this.customerInfo.cellPhone;
        break;
      }
      case "businessPhone": {
        pNumber = this.customerInfo.businessPhone;
        break;
      }
      case "other": {
        pNumber = this.customerInfo.otherNumber;
        break;
      }
      default: {
        pNumber = this.customerInfo.customerPhoneNumber;
      }
    }
    return pNumber;
  }
  public setActions() {
    this.actions = [
      {
        type: "button",
        icon: "fa fa-paperclip",
        title: this.$parent.$t(
          "closedRepairOrders.roGrid.gridActions.roAttachments"
        ) as string,
        visible: (model: SearchRepairOrderListViewModel) => {
          return true;
        },
        action: (model: SearchRepairOrderListViewModel, storeid: string) => {
          this.viewAttachment(model);
        },
      },
      {
        type: "link",
        icon: "fa fa-comment",
        title: this.$parent.$t(
          "closedRepairOrders.roGrid.gridActions.sendText"
        ) as string,
        visible: (model: SearchRepairOrderListViewModel) => {
          return (
            this.searchedRepairOrder.isMessagingEnabled &&
            model.customerKey !== "0" &&
            model.customerKey &&
            this.searchedRepairOrder.isAdvisorRole &&
            this.isFeatureToAccess("MESSAGING")
          );
        },
        action: (model: SearchRepairOrderListViewModel, storeid: string) => {
          return {
            name: "advisor.conversation.add",
            params: {
              tenantId: this.constants.tenantId,
              enterpriseId: this.constants.enterpriseId,
              storeId: this.constants.storeId,
              type: MetadataType[MetadataType.RO],
            },
            query: {
              customerSearch: "customerSearch",
              recordKey: model.repairOrderNumber || "",
              customerKey: model.customerKey,
              vin: model.vin,
            },
          };
        },
      },
      {
        type: "button",
        icon: "fa fa-phone",
        title: this.$parent.$t(
          "closedRepairOrders.roGrid.gridActions.callCustomer"
        ) as string,
        visible: (model: SearchRepairOrderListViewModel) => {
          return (
            this.searchedRepairOrder.isMessagingEnabled &&
            model.customerKey !== "0" &&
            model.customerKey &&
            this.searchedRepairOrder.isAdvisorRole &&
            this.isFeatureToAccess("MESSAGING")
          );
        },
        action: (model: SearchRepairOrderListViewModel, storeid: string) => {
          this.openCallPopup(model);
        },
      },
      {
        type: "link",
        icon: "fa fa-eye",
        title: "Close Ro Customer Follow Up",
        visible: (model: SearchRepairOrderListViewModel) => {
          let customerPhoneNumber = '';
          if (
            model.customerPhoneNumber &&
            model.customerPhoneNumber !== "0"
          )
            customerPhoneNumber = model.customerPhoneNumber;

          return customerPhoneNumber && customerPhoneNumber !== "0";
        },
        action: (model: SearchRepairOrderListViewModel) => {
          const customerPhoneNumber = model.customerPhoneNumber;
          return {
            name: "advisor.conversation.followup",
            params: {
              tenantId: this.constants.tenantId,
              enterpriseId: this.constants.enterpriseId,
              storeId: this.constants.storeId,
              type: MetadataType[MetadataType.ROFollowUp],
            },
            query: {
              customerPhoneNumber,
              customerKey: model.customerKey,
              recordKey: "",
              customerSearch: "customer",
            },
          };
        },
      },
    ];
    this.customerActions = [
      {
        type: "link",
        icon: "fa fa-comment",
        title: this.$parent.$t(
          "closedRepairOrders.roCustomerGrid.gridActions.textCustomer"
        ) as string,
        visible: (model: CustomerSearchResult) => {
          const customerPhoneNumber =
            model.homePhone && model.homePhone !== "0"
              ? model.homePhone
              : model.cellPhone;
          return (
            this.searchedRepairOrder.isAdvisorRole &&
            customerPhoneNumber &&
            customerPhoneNumber !== "0" &&
            this.searchedRepairOrder.isMessagingEnabled &&
            this.isFeatureToAccess("MESSAGING")
          );
        },
        action: (model: CustomerSearchResult, storeid: string) => {
          const customerPhoneNumber =
            model.homePhone && model.homePhone !== "0"
              ? model.homePhone
              : model.cellPhone;
          return {
            name: "advisor.conversation.add",
            params: {
              tenantId: this.constants.tenantId,
              enterpriseId: this.constants.enterpriseId,
              storeId: this.constants.storeId,
              type: MetadataType[MetadataType.RO],
            },
            query: {
              customerPhoneNumber,
              customerKey: model.customerNumber,
              recordKey: "",
              customerSearch: "customer",
            },
          };
        },
      },
      {
        type: "button",
        icon: "fa fa-phone",
        title: this.$parent.$t(
          "closedRepairOrders.roCustomerGrid.gridActions.callCustomer"
        ) as string,
        visible: (model: CustomerSearchResult) => {
          const customerPhoneNumber =
            model.homePhone && model.homePhone !== "0"
              ? model.homePhone
              : model.cellPhone;
          return (
            this.searchedRepairOrder.isAdvisorRole &&
            customerPhoneNumber &&
            customerPhoneNumber !== "0" &&
            this.searchedRepairOrder.isMessagingEnabled &&
            this.isFeatureToAccess("MESSAGING")
          );
        },
        action: (model: CustomerSearchResult, storeId: string) => {
          this.openCallPopup(model);
        },
      },
      {
        type: "button",
        icon: "fas fa-info-circle",
        title: this.$parent.$t(
          "closedRepairOrders.roCustomerGrid.gridActions.viewDetails"
        ) as string,
        visible: (model: CustomerSearchResult) => {
          return true;
        },
        action: (model: CustomerSearchResult) => {
          this.constants.customerNumber = model.customerNumber;
          this.$router
            .push({
              name: "app.repairorders.closed",
              params: {
                tenantId: this.constants.tenantId,
                enterpriseId: this.constants.enterpriseId,
                storeId: this.constants.storeId,
              },
              query: {
                searchParameter: this.constants.searchParameter
                  .toString()
                  .trim(),
                searchString: this.constants.searchString,
                lastName: this.constants.lastName,
                firstName: this.constants.firstName,
                customerNumber: this.constants.customerNumber,
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
          this.searchRepairOrder(true);
        },
      },
      {
        type: "button",
        icon: "fas fa-edit",
        title: this.$parent.$t(
          "closedRepairOrders.roCustomerGrid.gridActions.edit"
        ) as string,
        visible: (model: CustomerSearchResult) => {
          return this.isFeatureToAccess("CUSTOMER-UPDATE-DMS");
        },
        action: (model: CustomerSearchResult) => {
          this.constants.customerNumber = model.customerNumber;
          this.$router
            .push({
              name: "app.customer.details",
              params: {
                tenantId: this.constants.tenantId,
                enterpriseId: this.constants.enterpriseId,
                storeId: this.constants.storeId,
                customerNumber: this.constants.customerNumber,
                customerKey: this.constants.customerKey,
              },
              query: {
                searchParameter: this.constants.searchParameter
                  .toString()
                  .trim(),
                searchString: this.constants.searchString,
                lastName: this.constants.lastName,
                firstName: this.constants.firstName,
                customerNumber: this.constants.customerNumber,
                email: this.constants.email,
                phone: this.constants.phone,
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        },
      },
    ];
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit("updateToolBar", buttons);
  }
  public callMethod(methodName): void {
    if (methodName === "search") {
      if (
        this.constants.searchParameter === "1" &&
        !this.constants.searchString
      ) {
        this.showAlert(false, this.$t("closedRepairOrders.alertROIsRequired"));
      } else if (
        this.constants.searchParameter === "2" &&
        !this.constants.searchString
      ) {
        this.showAlert(false, this.$t("closedRepairOrders.alertVINIsRequired"));
      } else if (
        this.constants.searchParameter === "3" &&
        !this.constants.firstName &&
        !this.constants.lastName &&
        !this.constants.email &&
        !this.constants.phone
      ) {
        this.showAlert(
          false,
          this.$t("closedRepairOrders.alertSearchParametersRequired")
        );
      } else {
        this.search();
      }
    }

    if (methodName !== "" && methodName === "search") {
      this.$emit("resetMethodName", methodName);
    }
  }

  public resetMethodName(methodName): void {
    this.$emit("resetMethodName", methodName);
  }

  public updateChildToolBar(buttons): void {
    if (this.flags.showForm) {
      this.updateToolBar(buttons);
    } else {
      this.updateToolBar(null);
    }
  }

  public updateToolBar(additionalButtons): void {
    let buttons: any = [];
    if (additionalButtons) {
      buttons = buttons.concat(additionalButtons);
    }
    this.$emit("updateToolBar", buttons);
  }

  public mounted() {
    // activating tab
    this.$root.$emit("sidebar.layout.vue", "customerSearch");

    this.updateToolBar(null);
    this.$watch("methodtoCall", (newVal, oldVal) => {
      if (newVal) {
        this.methodName = newVal;
        this.callMethod(newVal);
      }
    });
    this.$watch("flags.showForm", (newVal, oldVal) => {
      if (newVal === false) {
        this.updateToolBar(null);
      }
    });
    this.$watch("childProgress", (newVal, oldVal) => {
      this.$emit("update:progress", newVal);
    });

    if (this.$route.query.searchParameter) {
      this.constants.searchParameter = Number(
        this.$route.query.searchParameter
      );
    }
    if (this.$route.query.searchString) {
      this.constants.searchString = this.$route.query.searchString;
    }
    if (this.$route.query.lastName) {
      this.constants.lastName = this.$route.query.lastName;
    }
    if (this.$route.query.firstName) {
      this.constants.firstName = this.$route.query.firstName;
    }
    if (this.$route.query.customerNumber) {
      this.constants.customerNumber = this.$route.query.customerNumber;
    }
    if (this.$route.query.email) {
      this.constants.email = this.$route.query.email;
    }
    if (this.$route.query.phone) {
      this.constants.phone = this.$route.query.phone;
    }
    if (
      this.constants.searchParameter &&
      (this.constants.searchString ||
        this.constants.lastName ||
        this.constants.firstName ||
        this.constants.email ||
        this.constants.phone)
    ) {
      this.searchRepairOrder();
    }
    this.getSearchParameters();
    this.setActions();
  }

  public openCallPopup(model): void {
    this.customerInfo.customerPhoneNumber =
      model.customerPhoneNumber || model.homePhone || "";
    this.customerInfo.customerBusinessPhone =
      model.customerBusinessPhone || model.businessPhone || "";
    this.customerInfo.cellPhone = model.cellPhone || "";
    this.customerInfo.customerName =
      model.customerName || model.lastName + " " + model.firstName;
    this.customerInfo.customerEmail = model.customerEmail || model.email1 || "";
    this.customerInfo.appointmentNumber = model.appointmentNumber || "";
    this.customerInfo.customerKey =
      model.customerKey || model.customerNumber || "";
    this.customerInfo.vin = model.vin || "";
    this.customerInfo.appointmentDate = model.appointmentDate || "";
    this.customerInfo.appointmentDateTime = model.appointmentDateTime || "";
    this.customerInfo.repairOrderNumber = model.repairOrderNumber || "";
    this.customerInfo.callType = this.searchedRepairOrder.callTypes[0].id;

    if (
      (this.customerInfo.customerPhoneNumber &&
        this.customerInfo.customerPhoneNumber !== "0") ||
      (this.customerInfo.customerBusinessPhone &&
        this.customerInfo.customerBusinessPhone !== "0") ||
      (this.customerInfo.cellPhone && this.customerInfo.cellPhone !== "0")
    ) {
      this.showCallPopup.model = true;
    } else {
      this.showAlert(
        false,
        this.$t("closedRepairOrders.alertPhoneNumberNotFound")
      );
    }
    this.customerInfo.callTo = "home";
    this.customerInfo.otherNumber = "";
  }
  public search(): void {
    const newQuery = {
      searchParameter: this.constants.searchParameter.toString().trim(),
      searchString: this.constants.searchString,
      lastName: this.constants.lastName,
      firstName: this.constants.firstName,
      email: this.constants.email,
      phone: this.constants.phone,
    };
    const isSameRoute =
    JSON.stringify(this.$route.query) === JSON.stringify(newQuery);

    if (isSameRoute) {
      this.searchRepairOrder();
      return;
    }
    
    this.constants.customerNumber = "";
    this.$router
      .push({
        name: "app.repairorders.closed",
        params: {
          tenantId: this.constants.tenantId,
          enterpriseId: this.constants.enterpriseId,
          storeId: this.constants.storeId,
        },
        query: {
          searchParameter: this.constants.searchParameter.toString().trim(),
          searchString: this.constants.searchString,
          lastName: this.constants.lastName,
          firstName: this.constants.firstName,
          email: this.constants.email,
          phone: this.constants.phone,
        },
      })
      .catch((ex) => {
        console.log(ex);
      });
    // this.searchRepairOrder();
  }
  public async searchRepairOrder(isSearchRO: boolean = false): Promise<void> {
    try {
      if (isSearchRO) {
        this.roLoading = true;
      } else {
        this.loading = true;
      }
      const response = await repairOrderService.getClosedRO(
        this.constants.searchParameter,
        this.constants.searchString,
        this.constants.firstName,
        this.constants.lastName,
        this.constants.email,
        this.constants.phone,
        this.constants.customerNumber
      );
      this.flags.showForm = false;
      this.flags.showAttachmentDetails = false;

      this.searchedRepairOrder = response;
      if (this.searchedRepairOrder.repairOrderList) {
        this.searchedRepairOrder.repairOrderList.forEach((order) => {
          const user = this.searchedRepairOrder.userList.find((u) => {
            return u.dmsServiceWriterID === order.serviceWriterID;
          });
          if (user) {
            order["serviceWriter"] = user.firstName + " " + user.lastName;
          } else {
            order["serviceWriter"] = order.serviceWriterID;
          }
        });
        this.pagedRO = this.searchedRepairOrder.repairOrderList;
        this.pagination.totalItems = this.pagedRO.length;
      }
      if (
        this.searchedRepairOrder.customerList &&
        this.searchedRepairOrder.customerList.length > 0
      ) {
        this.pagedCustomerList = this.searchedRepairOrder.customerList;
      }
    } finally {
      this.loading = false;
      this.roLoading = false;
    }
  }
  public viewAttachment(model: SearchRepairOrderListViewModel): void {
    this.constants.roNumber = model.repairOrderNumber;
    this.flags.showForm = true;
  }
  public updatePaging(paging: any) {
    this.pagination = paging;
  }
  public customerPaging(paging): void {
    this.customerPagination = paging;
  }
  public updateFlag(flag, value) {
    this.flags[flag] = value;
  }

  public async getSearchParameters(): Promise<void> {
    try {
      if (cachedSearchParameters && cachedSearchParameters.length > 0) {
        this.searchParameters = cachedSearchParameters;
        return;
      }

      this.searchParametersLoading = true;
      const response = await repairOrderService.getSearchParameters();
      this.searchParameters = response.results;
      cachedSearchParameters = response.results;
      if (!this.$route.query.searchParameter) {
        this.constants.searchParameter =
          this.searchParameters[this.searchParameters.length - 1].value;
      }
    } finally {
      this.searchParametersLoading = false;
    }
  }
  public async makeCall(): Promise<void> {
    try {
      this.showCallPopup.loading = true;
      this.showCallPopup.action.disable = true;
      const voiceCallModel: VoiceCallModel = {
        callType: this.customerInfo.callType,
        customerKey: this.customerInfo.customerKey,
        customerName: this.customerInfo.customerName,
        recordIdentifier: MetadataType[MetadataType.RO],
        recordKey: this.customerInfo.repairOrderNumber,
        recordKeyIdentifier:
          MetadataKeyIdentifier[MetadataKeyIdentifier.RepairOrderNumber],
        toNumber: this.customerPhoneNumber(),
        vin: this.customerInfo.vin,
      };

      if (!voiceCallModel.toNumber || voiceCallModel.toNumber === "0") {
        this.showAlert(
          false,
          this.$t("closedRepairOrders.alertCustomerPhoneNumberCanNotEmpty")
        );
        return;
      }
      const response = await voiceCallService.makeOutboundCallAsync(
        voiceCallModel
      );
      if (response.isSuccess) {
        this.showAlert(true, response.message);
      } else {
        this.showAlert(
          false,
          this.$t("closedRepairOrders.alertSomeErrorOccurredWhileMakingCall")
        );
      }
      this.showCallPopup.model = false;
    } finally {
      this.showCallPopup.loading = false;
      this.showCallPopup.action.disable = false;
    }
  }
}
export default ClosedRepairOrderPage;
